export default __webpack_public_path__ + "static/media/100_19106.e33060d9.jpg";